import React, { Component } from 'react';
import './PrismButton.scss';

class PrismButton extends Component {

  shouldClick() {
    if (this.props.disabled) return;
    else if (this.props.onClick) this.props.onClick();
  }

  render() {
    const { small, disabled, style, children } = this.props;
    let className = 'button-div';
    if (disabled) className += ' disabled';
    if (small) className += ' small';

    return (
      <div
        style={style}
        onClick={this.shouldClick.bind(this)}
        className={`${className} ${this.props.className ? this.props.className : '' }`}>
        <span className="button-text">
          {children}
        </span>
      </div>
    );
  }
}

export { PrismButton };


// WEBPACK FOOTER //
// ./src/components/PrismButton.js